import { Box, ToggleButton, ToggleButtonGroup, toggleButtonGroupClasses } from "@mui/material";
import React, { ReactNode } from "react";
import { MealPlanTemplateTab } from "../../pages/Auth/Org/MealPlans/MealPlanTemplatesPage";

interface MealPlanTemplatesHeaderProps {
  tab: MealPlanTemplateTab;
  onChangeTab: (tab: MealPlanTemplateTab) => void;
  hasOrgGroupTemplates: boolean;
  children?: ReactNode;
}

export const MealPlanTemplatesHeader = ({ tab, onChangeTab, children, hasOrgGroupTemplates }: MealPlanTemplatesHeaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
      }}
    >
      <ToggleButtonGroup
        sx={{
          border: 1,
          borderColor: "#EAECF0",
          borderRadius: 1.5,
          backgroundColor: "#F8FAFB",
          [`& .${toggleButtonGroupClasses.grouped}`]: {
            border: 0,
            borderRadius: 1,
          },
        }}
        exclusive
        value={tab}
        onChange={(e, value) => {
          if (value) {
            onChangeTab(value as MealPlanTemplateTab);
          }
        }}
      >
        <ToggleButton
          sx={{
            m: 0.25,
            px: 2,
            py: 0.75,
            fontSize: 14,
            fontWeight: 600,
            backgroundColor: "#F8FAFB",
            "&.Mui-selected": {
              boxShadow: 1,
              border: 1,
              borderColor: "#EAECF0",
              backgroundColor: "white",
            },
          }}
          value="org"
        >
          Organization Templates
        </ToggleButton>

        {hasOrgGroupTemplates && (
          <ToggleButton
            sx={{
              m: 0.25,
              px: 2,
              py: 0.75,
              fontSize: 14,
              fontWeight: 600,
              backgroundColor: "#F8FAFB",
              "&.Mui-selected": {
                boxShadow: 1,
                border: 1,
                borderColor: "#EAECF0",
                backgroundColor: "white",
              },
            }}
            value="orgGroup"
          >
            Org Group Templates
          </ToggleButton>
        )}

        <ToggleButton
          sx={{
            m: 0.25,
            px: 2,
            py: 0.75,
            fontSize: 14,
            fontWeight: 600,
            backgroundColor: "#F8FAFB",
            "&.Mui-selected": {
              boxShadow: 1,
              border: 1,
              borderColor: "#EAECF0",
              backgroundColor: "white",
            },
          }}
          value="staff"
        >
          Nutrition Templates
        </ToggleButton>
      </ToggleButtonGroup>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
